"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _IncludedAddons = _interopRequireDefault(require("./IncludedAddons"));

require("../styles/_subscription-package.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getSubscriptionEnd(subEnd) {
  if (!subEnd) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      className: "subscription-package__details-container__details__expires"
    }, "Does not expire");
  }

  var subEndDate = (0, _moment.default)(subEnd);
  var isExpired = subEndDate.isBefore((0, _moment.default)());
  var formattedDate = subEndDate.format('DD/MM/YYYY');
  var text = isExpired ? "Expired on ".concat(formattedDate) : "Expires ".concat(formattedDate);
  return /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: (0, _classnames.default)('subscription-package__details-container__details__expires', {
      'subscription-package__details-container__details__expires--expired': isExpired
    })
  }, text);
}

var SubscriptionPackage = function SubscriptionPackage(_ref) {
  var orgPackage = _ref.orgPackage;

  if (!orgPackage) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
      rounded: true,
      className: "subscription-package"
    });
  }

  var videoQuantity = orgPackage.videoQuantity,
      slaTurnaround = orgPackage.slaTurnaround,
      templatedFrom = orgPackage.templatedFrom,
      iconName = orgPackage.iconName,
      subEnd = orgPackage.subEnd,
      includedAddonTypes = orgPackage.includedAddonTypes;
  var packageParams = ["".concat(videoQuantity === -1 ? 'Unlimited' : videoQuantity, " Videos"), "".concat(slaTurnaround, "h SLA")].join(' | ');
  return /*#__PURE__*/_react.default.createElement(_uiKit.ElevatedContainer, {
    rounded: true,
    className: "subscription-package"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "subscription-package__details-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
    defaultImageIcon: iconName,
    defaultIconBackground: "catSkillWhite",
    defaultIconColour: "michael",
    width: "90px",
    height: "90px"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "subscription-package__details-container__details"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true,
    className: "subscription-package__details-container__details__type"
  }, templatedFrom.toLowerCase()), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "subscription-package__details-container__details__params"
  }, packageParams), getSubscriptionEnd(subEnd))), includedAddonTypes && includedAddonTypes.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: "subscription-package__addons-container"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Included Add-Ons"), /*#__PURE__*/_react.default.createElement(_IncludedAddons.default, {
    includedAddonTypes: includedAddonTypes
  })) : null);
};

var _default = SubscriptionPackage;
exports.default = _default;